import React from "react"
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"

function Privacy() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Privacy</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>Privacy</h1>
        <p>
          International Software Products and International Software Products,
          Inc. (collectively known herein as ISP)
        </p>
        <h4>Privacy Policy</h4>
        <p>
          ISP is committed to respecting and protecting your privacy and we have
          prepared this privacy statement to disclose and describe our
          information gathering and dissemination practices for this website.
        </p>
        <h4>Notice & Disclosure</h4>
        <p>
          You may visit this website without identifying yourself or revealing
          any personal information. ISP does NOT collect information from your
          visit to our website. You may NOT visit our FTP Site as provided on
          this website without the appropriate User Id and Password being
          provided to you by ISP or its related Business Partners or Affiliates.
        </p>
        <h4>Business Relationships:</h4>
        <p>
          This website contains links to other websites. ISP is not responsible
          for the privacy practices or the content of such websites.
        </p>
        <h4>Contacting Us:</h4>
        <p>
          If you have any questions or comments about our privacy statement or
          practices, please contact us via email at{" "}
          <a
            href="mailto:info@intnlsoftwareproducts.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            info@intnlsoftwareproducts.com
          </a>{" "}
          with the words "PRIVACY POLICY" in the subject line.
        </p>
        <p>
          <strong>
            ISP reserves the right to modify or update this privacy statement at
            any time without notice.
          </strong>
        </p>
      </Container>
    </Layout>
  )
}

export default Privacy
